import Button from '@mui/material/Button';
import React, { FC } from 'react';
import { ICompetitionReportsWidget } from './types';
import { useReportDownload } from './lib';

const CompetitionReportsWidget: FC<ICompetitionReportsWidget> = ({ id, title }) => {
  const download = useReportDownload(id, title);

  return (
    <Button
      onClick={download}
      style={{
        backgroundColor: '#4782DA',
        textTransform: 'none',
      }}
      variant="contained"
    >
      Скачать отчет
    </Button>
  );
};

export { CompetitionReportsWidget };
